var exports = {
  "J": "ProfileCardContent.module__contentSection___S3VnTH",
  "s": "ProfileCardContent.module__contentSectionWebhook___S3VnTH",
};

module.exports = exports;
